module.exports = __webpack_public_path__ + "assets/Underbite.888fbcb2c1a2a4bb7038eefd5e487414.svg";